 export const getFinalPrice=(price) =>{
   if (price != null) {
     if (price % 100 == 0) {
       return price / 100
      } else {
        return price / 100
      }
    } else {
      return ''
    }
  }